<template>
  <dx-date-box
    displayFormat="MMMM yyyy"
    type="month"
    :value="this.filterValue"
    @valueChanged="this.onFilterValueChanged"
  />
</template>

<script>
import DxDateBox from "devextreme-vue/date-box";

export default {
  components: {
    DxDateBox,
  },
  props: {
    filterValue: {
      type: Date,
      default: null,
    },
  },
  methods: {
    onFilterValueChanged(value) {
      this.$emit("filterChanged", {
        value,
      });
    },
  },
};
</script>
